import { render, staticRenderFns } from "./ModalFilter.vue?vue&type=template&id=2b6644b4&"
import script from "./ModalFilter.vue?vue&type=script&lang=js&"
export * from "./ModalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports